import React, { useState } from 'react'
import './styles.scss'
import Picture from '../picture'

// const url = './data.json';

const data = require('./data.js')

function Grid(props) {
  return <div className='grid'>{props.children}</div>
}

function Calendar() {
  const n = new Date(Date.now())
  // const n = new Date('2020-12-01')

  const [open, setOpen] = useState(null)
  // const [data, setData] = useState([]);

  // fetch(url)
  // .then(response => response.json())
  // .then(d => setData(d))
  // .catch(error => {
  //   console.error('Error:', error)
  // })

  const doorClicked = e => {
    if (n.getFullYear() > 2020) {
      setOpen(e)
    } else {
      if (n.getMonth() >= 11 && n.getDate() >= e) {
        setOpen(e)
      } else {
        console.log('Meimei! Türchen zu früh öffnen ist verboten!')
      }
    }
  }

  return (
    <Grid>
      {data.map(e => (
        <Picture
          key={e.day}
          no={e.day}
          title={e.title}
          lead={e.lead}
          url={e.url}
          active={open}
          onClick={doorClicked}
          goldBorder={
            n.getFullYear() === 2020 &&
            n.getMonth() === 11 &&
            n.getDate() === e.day
          }
        />
      ))}
    </Grid>
  )
}

export default Calendar
